module.exports = __webpack_public_path__ + "ebef2fd012fee61422f82a13482125e9.svg";